import { render, staticRenderFns } from "./suratjalan.vue?vue&type=template&id=572209ca"
import script from "./suratjalan.vue?vue&type=script&lang=js"
export * from "./suratjalan.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports